module.exports = __webpack_public_path__ + "static/img/logo.0f7c00b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/logo.png
// module id = 145
// module chunks = 63